import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLID,
  GraphQLNonNull
} from 'graphql'

export interface Module {
  readonly id: string
  readonly name: string
}

export const ModuleType = new GraphQLObjectType({
  name: 'Module',
  fields: () => ({
    id: {
      description: 'The unique ID for an application module',
      type: new GraphQLNonNull(GraphQLID)
    },
    name: {
      description: 'Human readable name for the application module',
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})
